function productCarousel() {
  const carousel = document.querySelector("[data-carousel]");
  if (!carousel) return;

  const container = carousel.closest(
    ".shimokita-honey__product-lineup__carousel-container",
  );

  if (container) {
    container.addEventListener("mouseenter", () => {
      container.classList.add("is-hovered");
    });

    container.addEventListener("mouseleave", () => {
      container.classList.remove("is-hovered");
    });
  }

  const prevBtn = document.querySelector("[data-prev]");
  const nextBtn = document.querySelector("[data-next]");

  const ITEMS_PER_CLICK = 1;

  let isDesktop = window.innerWidth > 767;
  let isDown = false;
  let isDragging = false;
  let startX;
  let scrollLeft;

  const getItemWidth = () => {
    const firstItem = carousel.querySelector("li");
    if (!firstItem) return 0;
    const style = window.getComputedStyle(firstItem);
    const marginRight = parseFloat(style.marginRight) || 0;
    return firstItem.offsetWidth + marginRight;
  };

  const scrollByItems = (count) => {
    const itemWidth = getItemWidth();
    carousel.scrollBy({
      left: itemWidth * count,
      behavior: "smooth",
    });
  };

  const updateMode = () => {
    isDesktop = window.innerWidth > 767;
    updateButtons();
  };

  const updateButtons = () => {
    if (!prevBtn || !nextBtn) return;

    if (carousel.scrollLeft <= 0) {
      prevBtn.classList.add("disabled");
    } else {
      prevBtn.classList.remove("disabled");
    }

    if (
      carousel.scrollLeft + carousel.clientWidth >=
      carousel.scrollWidth - 1
    ) {
      nextBtn.classList.add("disabled");
    } else {
      nextBtn.classList.remove("disabled");
    }
  };

  // Buttons
  if (nextBtn) {
    nextBtn.addEventListener("click", () => {
      if (!isDesktop) return;
      scrollByItems(ITEMS_PER_CLICK);
      setTimeout(updateButtons, 300);
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener("click", () => {
      if (!isDesktop) return;
      scrollByItems(-ITEMS_PER_CLICK);
      setTimeout(updateButtons, 300);
    });
  }

  // Drag to scroll
  carousel.addEventListener("mousedown", (e) => {
    if (!isDesktop) return;
    isDown = true;
    isDragging = false;
    startX = e.pageX - carousel.offsetLeft;
    scrollLeft = carousel.scrollLeft;
  });

  carousel.addEventListener("mousemove", (e) => {
    if (!isDown || !isDesktop) return;
    const x = e.pageX - carousel.offsetLeft;
    const walk = x - startX;

    if (Math.abs(walk) > 5) {
      if (!isDragging) {
        isDragging = true;
        carousel.classList.add("is-dragging");
      }
      e.preventDefault();
      carousel.scrollLeft = scrollLeft - walk;
      updateButtons();
    }
  });

  const endDrag = () => {
    isDown = false;
    if (isDragging) {
      isDragging = false;
      carousel.classList.remove("is-dragging");
    }
    updateButtons();
  };

  carousel.addEventListener("mouseup", endDrag);
  carousel.addEventListener("mouseleave", endDrag);

  carousel.addEventListener("click", (e) => {
    if (isDragging) {
      e.stopPropagation();
      e.preventDefault();
    }
  });

  carousel.querySelectorAll("img").forEach((img) => {
    img.setAttribute("draggable", "false");
  });

  window.addEventListener("resize", updateMode);

  updateButtons();

  carousel.addEventListener("scroll", updateButtons);
}

productCarousel();
